import Button from './Button';
import ButtonGroup from './ButtonGroup';

Button.Group = ButtonGroup;

export {
  Button
};
